export const SCREEN_FORMULA_QUERY_KIND = 'SCREEN_FORMULA';
export const SCREEN_FORMULA_ENGINE = 'arithmetic';

export const SCREEN_FORMULA_AST_TYPE = {
  COMPARISON: 'compare',
  BINARY: 'binary',
  UNARY: 'unary',
  NUMBER: 'number',
  FIELD: 'field',
};

export const SCREEN_FORMULA_ALIAS_ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
export const SCREEN_FORMULA_ALIAS_RADIX = SCREEN_FORMULA_ALIAS_ALPHABET.length;
export const SCREEN_FORMULA_ALIASES = SCREEN_FORMULA_ALIAS_ALPHABET.split('');
export const SCREEN_FORMULA_ALIAS_PATTERN = /^[A-Z]+$/;

export const SCREEN_FORMULA_OPERATOR = {
  EQ: 'eq',
  NE: 'ne',
  GT: 'gt',
  GTE: 'gte',
  LT: 'lt',
  LTE: 'lte',
};

export const SCREEN_FORMULA_OPERATOR_OPTIONS = [
  { value: SCREEN_FORMULA_OPERATOR.EQ, label: 'equals' },
  { value: SCREEN_FORMULA_OPERATOR.NE, label: 'does not equal' },
  { value: SCREEN_FORMULA_OPERATOR.GT, label: 'greater than' },
  { value: SCREEN_FORMULA_OPERATOR.GTE, label: 'greater than or equal to' },
  { value: SCREEN_FORMULA_OPERATOR.LT, label: 'less than' },
  { value: SCREEN_FORMULA_OPERATOR.LTE, label: 'less than or equal to' },
];

export const SCREEN_FORMULA_AST_OPERATOR = {
  [SCREEN_FORMULA_OPERATOR.EQ]: '==',
  [SCREEN_FORMULA_OPERATOR.NE]: '!=',
  [SCREEN_FORMULA_OPERATOR.GT]: '>',
  [SCREEN_FORMULA_OPERATOR.GTE]: '>=',
  [SCREEN_FORMULA_OPERATOR.LT]: '<',
  [SCREEN_FORMULA_OPERATOR.LTE]: '<=',
};

export const SCREEN_FORMULA_AST_OPERATOR_BY_SYMBOL = Object.fromEntries(
  Object.entries(SCREEN_FORMULA_AST_OPERATOR).map(([key, value]) => [value, key]),
);

export const SCREEN_FORMULA_TARGET_UNIT = {
  PERCENT: 'percent',
  NUMBER: 'number',
};

export const SCREEN_FORMULA_PERCENT_SCALE = 100;

export const SCREEN_FORMULA_TARGET_UNIT_OPTIONS = [
  { value: SCREEN_FORMULA_TARGET_UNIT.PERCENT, label: '%' },
  { value: SCREEN_FORMULA_TARGET_UNIT.NUMBER, label: 'Number' },
];

export const BRE_CONDITION_MODE = {
  RULES: 'rules',
  FORMULA: 'formula',
};

export const BRE_CONDITION_MODE_OPTIONS = [
  { value: BRE_CONDITION_MODE.RULES, label: 'Rules' },
  { value: BRE_CONDITION_MODE.FORMULA, label: 'Formula' },
];
